var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "regionalManagerWrap" },
    [
      _c("div", { staticClass: "form-wrap" }, [
        _c("div", { staticClass: "seach" }, [
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择集配中心" },
                  model: {
                    value: _vm.formData.logistic_business_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "logistic_business_id", $$v)
                    },
                    expression: "formData.logistic_business_id",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入区域负责人" },
                model: {
                  value: _vm.formData.fullname,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fullname", $$v)
                  },
                  expression: "formData.fullname",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入电话" },
                model: {
                  value: _vm.formData.mobile,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "mobile", $$v)
                  },
                  expression: "formData.mobile",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择管辖区域(省)" },
                  model: {
                    value: _vm.formData.province_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "province_code", $$v)
                    },
                    expression: "formData.province_code",
                  },
                },
                _vm._l(_vm.province_list, function (item) {
                  return _c("el-option", {
                    key: item.area_code,
                    attrs: { label: item.name, value: item.area_code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择管辖区域(市)" },
                  model: {
                    value: _vm.formData.city_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "city_code", $$v)
                    },
                    expression: "formData.city_code",
                  },
                },
                _vm._l(_vm.city_list, function (item) {
                  return _c("el-option", {
                    key: item.area_code,
                    attrs: { label: item.name, value: item.area_code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择城市仓",
                  },
                  model: {
                    value: _vm.formData.logistics_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "logistics_id", $$v)
                    },
                    expression: "formData.logistics_id",
                  },
                },
                _vm._l(_vm.tdcList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  clearable: false,
                  "start-placeholder": "供货周期起",
                  "end-placeholder": "供货周期止",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                },
                on: { change: (val) => _vm.addTimeChange(val) },
                model: {
                  value: _vm.change_time,
                  callback: function ($$v) {
                    _vm.change_time = $$v
                  },
                  expression: "change_time",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inputs" },
            [
              _c("el-button", {
                staticClass: "refresh",
                attrs: { type: "primary", icon: "el-icon-refresh" },
                on: { click: _vm.onHandleRefresh },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.onSearch },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editPop("新增")
                    },
                  },
                },
                [_vm._v("添加")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    disabled: !_vm.tableData.length || _vm.disabledExport,
                    icon: "el-icon-download",
                  },
                  on: { click: _vm.exportHandle },
                },
                [_vm._v("导 出")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "fullname",
                  align: "center",
                  label: "区域负责人",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", align: "center", label: "电话" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "area_list_txt",
                  align: "center",
                  label: "管辖区域",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "register_num",
                  align: "center",
                  label: "新开客",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "register_user_total",
                  align: "center",
                  label: "累计新开客",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "creator_user_total",
                  align: "center",
                  label: "累计建档客户",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sales_qty",
                  align: "center",
                  label: "销量(件)",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sales_tonnage",
                  align: "center",
                  label: "销量(吨)",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "follow_record_num",
                  align: "center",
                  label: "回访数量",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "follow_record_90_num",
                  align: "center",
                  label: "90天内总回访占比",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistics\n",
                  align: "center",
                  label: "管辖城市仓",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getLogistics(scope.row.logistics)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "state_txt",
                  align: "center",
                  label: "状态",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "op_name",
                  align: "center",
                  label: "操作",
                  fixed: "right",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editPop("编辑", scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("editManager", {
        ref: "infoPop",
        attrs: {
          tdcList: _vm.tdcList,
          options: _vm.options,
          areaList: _vm.areaList,
        },
        on: { "submit-form": _vm.onHandleRefresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }